import { convertFromWei } from 'utils/formatBalances'
import { normalizeDealState } from 'submission/lib/deal-api'
import useSWR from 'swr'

const fetcher = (url: string) =>
  fetch(url, {
    credentials: 'include',
    headers: [['Cache-Control', 'no-cache']],
  }).then((res) => res.json())

const useListV2 = () => {
  const { data, error, isLoading, mutate } = useSWR(
    `${process.env.REACT_APP_BACKEND_URL}/api/v2/admin/deals`,
    fetcher,
  )

  const deals = Array.isArray(data?.data) ? data.data : []
  const normalizedDeals = deals.map((project: any) => {
    const overview = project?.metadata?.overview ?? {}
    const detail = project?.metadata?.detail
    const pricingPayload = detail?.pricingBlob?.payload
    const v1Metadata = project?.metadata?.v1
    const contractVersion = pricingPayload ? 'v2' : 'v1'

    const formattedStatus = (() => {
      if (!project?.status) {
        return 'Unknown'
      }

      return project.status
        .split('_')
        .map((word: string) =>
          word === 'ended'
            ? 'Completed'
            : word.charAt(0).toUpperCase() + word.slice(1),
        )
        .join(' ')
    })()

    return {
      id: project.id,
      projectName: overview.projectName ?? '',
      projectLogo: overview.logoUrl ?? '',
      tags: overview.categoryTags || [],
      saleType: v1Metadata?.saleType ?? overview?.salesType?.type,
      targetRaise: 0,
      totalRaised: convertFromWei(project.total_raised_in_wei ?? 0).toNumber(),
      minRaise: convertFromWei(project.min_raised ?? 0).toNumber(),
      maxRaise: convertFromWei(project.max_raised ?? 0).toNumber(),
      fdv: pricingPayload
        ? convertFromWei(pricingPayload.fdvInWei ?? 0).toNumber()
        : 0,
      participants: project.participant_count ?? 0,
      status: formattedStatus,
      state: normalizeDealState(project?.state),
      projectUrls: overview.urls ?? {},
      tgeDate:
        project?.metadata?.timelines?.find(
          (entry: any) => entry?.type === 'firstUnlock',
        )?.datetime ?? null,
      timelines: project?.metadata?.timelines ?? [],
      platformFeePercent: project.platform_fee_percent ?? 0,
      depositChainId:
        detail?.depositChainId ?? v1Metadata?.depositChainId ?? null,
      submittedAt:
        project.submitted_at ??
        project.updated_at ??
        project.created_at ??
        new Date().toISOString(),
      contractVersion,
    }
  })

  return {
    data: normalizedDeals,
    isLoading,
    isError: error,
    mutate,
  }
}

export default useListV2
